module.exports = __webpack_public_path__ + "packs/media/images/Slider_2-ce4816bf74d15ce60d4f8b0eb7ab442e.jpg";